/**
 * global
 */
export const API_KEY = '6aafa38fd9f98d3c773d51ce51781214375fcc1a3cfdddc28f5d665fe67c499c';
const getAPIHost = (host) => {
    switch(host) {
      case 'editor.audory.io':
      case 'editor.live.audory.io':
        return 'https://api3.audory.io/api';
      case 'editor.dev.audory.io':
        return 'https://api3.audory.io/api';
      case 'localhost':
        return 'https://api3.audory.io/api';
        return 'http://localhost:5000/api';
      default:
        return 'https://api3.audory.io/api';
    }
  };
  export const API_HOST = getAPIHost(window.location.hostname);

/**
 * user
 */
export const ENDPOINT_USER = `${API_HOST}/Accounts`;
export const ENDPOINT_USER_SESSION = `${API_HOST}/Accounts/login`;
export const ENDPOINT_USER_LOGOUT = `${API_HOST}/Accounts/logout`;
export const ENDPOINT_USER_REGISTER = `${API_HOST}/Accounts`;
export const ENDPOINT_USER_PROFILE = `${API_HOST}/EditorUserSettings`;

/**
 * audio
 */
export const ENDPOINT_FILESTORAGE_AUDIO = `${API_HOST}/Containers/audory-audio-input/upload`;
export const ENDPOINT_FILEREAD_AUDIO = `${API_HOST}/Audios/signed`;


export const ENDPOINT_FILEREAD_COVER = `${API_HOST}/Covers/signed`;
/**
 * categories
 */
export const ENDPOINT_CATEGORIES = `${API_HOST}/Categories`;

/**
 * projects
 */
export const ENDPOINT_PROJECT = `${API_HOST}/editordata/_table/project`;
export const ENDPOINT_PROJECTVERSION = `${API_HOST}/gamedata/_table/projectstate`;
export const ENDPOINT_PUBLISHEDGAMES = `${API_HOST}/stories/_table/published`;


export const ENDPOINT_STORY = `${API_HOST}/Stories`;
export const ENDPOINT_PAGE = `${API_HOST}/Pages`;

export const ENDPOINT_PROFILE = `${API_HOST}/profiles`;


// WEBPACK FOOTER //
// ./src/api/constants.js